import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {appType} from "../utils/audit-utils.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
  const handleSpecialInput = useGeneralInputSpecialCase(setFilters);

  return (
    <>
      <div className={`mb-2 ${minMenuHeight}`}>
        <form className={'space-y-4'}>
          <div>
            <InputDateTime
              id="dtStart"
              label="Data/hora inicial *"
              selected={filters.dtStart}
              onChange={date => handleSpecialInput("dtStart", date)}
            />
          </div>
          <div>
            <InputDateTime
              id="dtEnd"
              label="Data/hora final *"
              selected={filters.dtEnd}
              onChange={date => handleSpecialInput("dtEnd", date)}
            />
          </div>
          <div>
            <SelectComponent
              id="application"
              label="Aplicação"
              options={appType}
              value={appType.find(el => el.value === filters.application)}
              onChange={selected => handleSpecialInput("application", selected?.value)}
              isClearable={false}
            />
          </div>
          <div className="ml-1">
            <InputCheckbox
              id="searchDetails"
              label="Exibir detalhes"
              checked={filters.searchDetails}
              onChange={() => setFilters(prev => ({...prev, searchDetails: !prev.searchDetails}))}
            />
          </div>
          <AccessForm filters={filters} setFilters={setFilters} isMulti={false}/>
        </form>
      </div>
    </>
  );
};

export default Filters;